export type ConvertableItemType = {
  id: string;
  unitName: string;
  floorplanName: string;
  beds: string;
  baths: string;
  price: string;
  squareFeet: string;
};

export const ConvertableItem = ({
  id = '',
  unitName = '',
  floorplanName = '',
  beds = '',
  baths = '',
  price = '',
  squareFeet = '',
}: Partial<ConvertableItemType> = {}): ConvertableItemType => ({
  id: String(id),
  floorplanName: String(floorplanName),
  unitName: String(unitName),
  beds: String(beds),
  baths: String(baths),
  price: String(price),
  squareFeet: String(squareFeet),
});

export type ConvertableOptionType = {
  label: string;
  value: string;
  convertableItem: ConvertableItemType;
};

type ConvertableOptionInput = {
  baths?: number | string;
  beds?: number | string;
  price?: number;
  squareFeet?: number | string;
  name?: string;
  floorplanName?: string;
  highPrice?: number;
  lowPrice?: number;
  id?: string;
};

export const ConvertableOption = ({
  baths,
  beds,
  price = 0,
  squareFeet,
  name = '',
  floorplanName = '',
  highPrice = 0,
  lowPrice = 0,
  id = '',
}: ConvertableOptionInput): ConvertableOptionType => {
  const displayText = floorplanName ? `${floorplanName} (Unit: ${name})` : `${name}`;
  let displayBeds: string | number = beds || '';
  if (beds === 0) {
    displayBeds = 'Studio';
  }
  const finalPrice = price || lowPrice || highPrice || 0;

  return {
    label: String(displayText),
    value: String(displayText),
    convertableItem: ConvertableItem({
      id: String(id),
      unitName: floorplanName ? String(name) : '',
      floorplanName: floorplanName ? String(floorplanName) : String(name),
      beds: String(displayBeds),
      baths: String(baths),
      price: String(finalPrice),
      squareFeet: String(squareFeet),
    }),
  };
};
